<template>
    <component
        v-if="component"
        :is="component"
        :formField="formField"
        :onChangeHandler="onChangeHandler"
        :compact="compact"
    />
</template>

<script>
import DropDown from './DropDown.vue';
import Radio from './Radio.vue';
import Checkbox from './Checkbox.vue';
import MyText from './MyText.vue';
import MyDate from './MyDate.vue';
import MyNumber from './MyNumber.vue';
import Address from './Address.vue';

const FILTER_COMPONENTS = {
    dropdown: DropDown,
    radio: Radio,
    checkbox: Checkbox,
    text: MyText,
    textarea: MyText,
    date: MyDate,
    number: MyNumber,
    address: Address,
};

export default {
    name: 'FormFieldFilter',
    components: {
        DropDown,
        Radio,
        Checkbox,
        MyText,
        MyDate,
        MyNumber,
        Address,
    },
    props: {
        formField: {
            required: true,
            type: Object,
        },
        onChangeHandler: {
            required: true,
            type: Function,
        },
        compact: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        component() {
            return FILTER_COMPONENTS[this.formField.type] ?? null;
        },
    },
};
</script>
